// extracted by mini-css-extract-plugin
export default {"list":"UpcomingList_list__UeSSV","empty":"UpcomingList_empty__V3jca"};